import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { SimpleGridCol, SimpleGridRow } from '../../store/reselectors/budget.data';
import { OnChanges } from '@angular/core';
import { minContents } from '../../helpers/table-helpers.data';
import { publicHelpers } from './../../helpers/public-helpers';
import { Dictionary } from '@ngrx/entity';
import { ExpandingWrapperComponent } from 'src/app/components/wrappers/expanding-wrapper.component';
import { CommonModule } from '@angular/common';
import { PrettyNumbersPipe } from 'src/app/services/pipes/prettyNumbers.pipe';

@Component({
    selector: 'simple-grid',
    templateUrl: './simple-grid.html',
    styleUrls: ['./simple-grid.scss', './budget-grid.scss'],
    styles: [`
  `],
    standalone: true,
    imports: [ExpandingWrapperComponent, PrettyNumbersPipe, CommonModule,],
})
export class SimpleGridComponent<T> implements OnChanges {
  @Input() columns: SimpleGridCol[] = []
  @Input() rows: SimpleGridRow<T>[] = []
  @Input() data: Dictionary<T> = {}
  @Input() startClosed = true
  @Input() closed = true
  @Input() title = ''

  gridTemplateColumns: string
  helpers = publicHelpers
  @Output() toggle: EventEmitter<void> = new EventEmitter()


  ngOnChanges() {
    this.setTemplates()
  }

  setTemplates() {
    this.gridTemplateColumns = `repeat(${this.columns.length + 1}, minmax(min-content, 1fr) )`
  }

}